import { Box, Center } from '@chakra-ui/layout'
import { Image, Stack, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Link as RouteLink } from 'react-router-dom'
import type { APIUser } from '../api'
import bib_footer from '../assets/img/bib_footer.png'
import { graphicalCharterLink } from '../i18n'
import { useUserAwareTranslation } from '../i18n/hooks'

interface FooterProps {
  user?: APIUser
}
const Footer = ({ user }: FooterProps) => {
  const { t } = useUserAwareTranslation(user)

  const [graphicalCharterPage, setGraphicalCharterPage] = useState('')

  useEffect(() => {
    graphicalCharterLink(user).then((pdf) => setGraphicalCharterPage(pdf || ''))
  }, [])

  return (
    <Center bg="#F5F3F1">
      <Box
        w="100%"
        mx={[6, 20, 20, 24, 40]}
        borderTopColor="#E8E8E8"
        borderTopWidth={1}
        pb={[4, 8]}
        pt={[8, 16]}>
        <Stack justify="center" alignItems="center" direction="column">
          <Image width="80px" align="center" src={bib_footer} />
          <Text fontSize={[12, 14]} textAlign="center" color="gray.600" lineHeight={2} mb={1}>
            {t('footer-copyright')}
          </Text>
          <Stack
            justify="center"
            spacing={[0, 4]}
            direction="row"
            divider={
              <Text fontSize={14} pl={[2, 4]} pr={[2, 4]}>
                .
              </Text>
            }>
            <RouteLink to={`/legal-notice`} target="_blank">
              <Text fontSize={14} color="gray.600" lineHeight={2}>
                {t('footer-legal-notice')}
              </Text>
            </RouteLink>
            <RouteLink to={`/terms-of-use`} target="_blank">
              <Text fontSize={14} color="gray.600" lineHeight={2}>
                {t('footer-terms-of-use')}
              </Text>
            </RouteLink>
            <RouteLink to={`/privacy-policy`} target="_blank">
              <Text fontSize={14} color="gray.600" lineHeight={2}>
                {t('footer-privacy-policy')}
              </Text>
            </RouteLink>
            {graphicalCharterPage && (
              <RouteLink to={graphicalCharterPage} target="_blank">
                <Text fontSize={14} color="gray.600" lineHeight={2}>
                  {t('footer-graphical-charter')}
                </Text>
              </RouteLink>
            )}
          </Stack>
        </Stack>
      </Box>
    </Center>
  )
}

export default Footer
